import { render, staticRenderFns } from "./work-order-sent-bglbj.vue?vue&type=template&id=0fbb6c82&scoped=true"
import script from "./work-order-sent-bglbj.vue?vue&type=script&lang=js"
export * from "./work-order-sent-bglbj.vue?vue&type=script&lang=js"
import style0 from "./work-order-sent-bglbj.vue?vue&type=style&index=0&id=0fbb6c82&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbb6c82",
  null
  
)

export default component.exports